<template>
  <div>
    <div class="DailyWork-company">
      <LeftDropDownMenu :MenuList="MenuList" :width="185"  ></LeftDropDownMenu>
      <div class="Menuline">
      </div>
      <div class="router">
        <router-view ref="routers"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import LeftDropDownMenu from '../components/leftDropDownMenu/leftDropDownMenu.vue'
import WorkReportTable from './WorkReport/components/WorkReportTable.vue'
import {
  UserInfoLicenseMenu
} from '@/api/channel'
export default {
  components: {
    LeftDropDownMenu,
    WorkReportTable
  },
  data() {
    return {
      MenuList: [],
      CusWebMenus: [],
      Menus: null,
      IDArr: [],
      MenusListTow: [],
      List: [
        
      ]
    }
  },
  mounted() {
    this.MenusList()
  },
  computed: {

  },

  methods: {
    MenusList() {
      // 获取渠道管理全部菜单
      this.CusWebMenus = JSON.parse(localStorage.getItem("MenusData")).CusWebMenus
      // 截取URL的MenuID
      let index = window.location.hash.lastIndexOf("?")
      let par = window.location.hash.substring(index + 1, window.location.hash.length);
      let pars = par.substring(0, 6)
      let MenuID = par.substring(par.lastIndexOf("=") + 1, par.length);
      // // 过滤获取到对应的菜单
      this.Menus = this.CusWebMenus.filter(item => item.NodeID == 77)
      // // 获取菜单列表MenuID
      this.MenuList = this.Menus[0].Nodes
      console.log(this.MenuList, 'MenusList');
      this.userInfoLicenseMenu()
    },
async userInfoLicenseMenu() {
      let {
        code,
        data,
        message
      } = await UserInfoLicenseMenu({})
      if (code == 0) {
        this.List = data
        this.MenuList.map((item, index) => {
          console.log(item, 'item');
          if (item.NodeID == '68') {
            // item.Nodes = []
            item.Nodes = this.List
          }
          this.MenusListTow.push(item)
        })
        console.log(this.List, 'this.List');
        console.log(this.MenuList, 'this.MenusListTow');
      } else {
        this.$notify.error({
          title: '提示',
          message: message
        })
      }
    }
  },
  watch: {

  },
}
</script>

<style lang="less" scoped>
.DailyWork-company {
  width: 1200px;
  min-height: 850px;
  max-height: 100%;
  background: #ffffff;
  border: 1px solid #e6e8eb;
  margin-top: 16px;
  margin-right: auto;
  margin-bottom: 100px;
  margin-left: auto;
  padding-top: 20px;
  position: relative;
  top: 16px;
  // user-select: none;

  .router {
    // border: 1px solid #00266d;
    width: 980px;
    height: 100%;
    position: relative;
    left: 200px;
    // top: 20px;
      // overflow: hidden;
  }
}
.breadcrumb {
  width: 1200px;
  //   border: 1px solid red;
  margin: 0 auto;
  position: relative;
  top: 8px;
  margin-bottom: -15px;
  div:nth-child(1):hover {
    color: #e71d43;
  }

  img {
    position: relative;
    top: 3px;
    margin-left: 10px;
    margin-right: 10px;
  }
  div:nth-child(1) {
    color: #9ca5b8;
  }

  div {
    font-size: 14px;
    font-weight: 500;
    display: inline-block;
    cursor: pointer;
  }
}
.Menuline {
  width: 1px;
  min-height: 96%;
  background-color: #e6e8eb;
  display: inline-block;
  position: absolute;
  left: 185px;
}
</style>